import React, { useState } from "react";

function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // TODO: Integrate with API for form submission
    setFormData({ name: "", phone: "", email: "", message: "" });
  };

  return (
    <section
      className="contact-section section-padding fix section-bg bg-cover"
      style={{ backgroundImage: "url(assets/img/contact/bg.png)" }}
    >
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-6">
            <div className="contact-wrapper">
              <div className="section-title">
                <span className="sub-title wow fadeInUp" style={{ color: "#00FF00" }}>
                  Contact Us
                </span>
                <h2 className="wow fadeInUp" data-wow-delay=".3s">
                  Let's Build An Awesome Project Together
                </h2>
              </div>
              <div className="contact-thumb">
                <img src="assets/img/contact/1.jpg" className="ex" alt="img" />
                <h4>
                  <img src="assets/img/icon/phone.svg" alt="phone" /> +254 742 940 940
                </h4>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="contact-form style-2">
              <h3>Fill The Contact Form</h3>
              <p>Feel free to contact with us, we don't spam your email</p>
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-6">
                    <div className="form-clt">
                      <input
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Your name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-clt">
                      <input
                        type="tel"
                        name="phone"
                        id="phone"
                        placeholder="Phone number"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-clt">
                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Email address"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-clt">
                      <textarea
                        name="message"
                        id="message"
                        placeholder="Write your message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-12">
                    <button type="submit" className="theme-btn style-2">
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;